module.exports = __webpack_public_path__ + "img/googlecloud.52255c71.png";